<ol data-automation-id="bookmarks-lists-list"
    [attr.aria-label]="'bookmarksListsListTitle' | translate">
  <li *ngFor="let list of lists; trackBy: trackById"
      class="d-block mb-5"
      data-automation-id="bookmarks-list-card">
    <app-ap-bookmark-list-card [list]="list" (onListOpened)="openList(list)"></app-ap-bookmark-list-card>
  </li>
</ol>
